import { AnyAction } from "redux";

const isNotFoundErrorAction = (
  action: AnyAction
): action is { type: string; error: Error } => {
  return isNotFound(action.error);
};

export const isNotFound = (error: Error): boolean =>
  error?.message.includes("Resource not found");

export default isNotFoundErrorAction;
